module.exports = __webpack_public_path__ + "581b2f397959d370981c51aa8cb08629.png";


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/referral/modals/plaid_logo.png
// module id = 1009
// module chunks = 0